import { Box } from "@twilio-paste/core/box";
import { Text } from "@twilio-paste/core/text";
import { AvatarWrapper } from "@twiliointernal/e2-commons-shared-ui";
import { MessageBlockRole } from "@twiliointernal/e2-commons-shared-definitions";

import EndedChatActions from "./sub/endedChatActions";

import { copy, types } from "./definitions";

const EndedChat = (props: types.EndedChatProps) => {
  return (
    <AvatarWrapper role={MessageBlockRole.Assistant}>
      <Text as="p">{copy.assistantMessage}</Text>
      <Box marginTop="space60">
        <EndedChatActions {...props} />
      </Box>
    </AvatarWrapper>
  );
};

export default EndedChat;
